<template>
	<v-form v-model="valid">
		<div v-if="concept">
			<span class="headline font-weight-light">
				{{concept}}
			</span>
			<br/>
			<br/>
		</div>
		<v-data-table
			:headers="innerHeaders"
			:items="rows"
			class="elevation-1"
			hide-default-footer
			no-data-text="Добавьте строки для просчёта"
			disable-pagination
		>
			<template v-slot:item="{item}">
				<tr>
					<td
						v-for="head in innerHeaders"
						:key="head.value"
						:class="!['percent', 'action', 'volume', 'volume_per'].includes(head.value) ? 'align-top' : ''"
					>
						<div v-if="item[head.value] === 'none_row'">
							Строка None
						</div>
						<div v-else-if="head.value === 'action'" class="text-center">
							<div v-if="!(item[Object.keys(item)[0]] === 'none_row')">
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon
											small
											@click="deleteRow(item.id)"
											v-on="on"
										>
											mdi-delete
										</v-icon>
									</template>
									<span>Удалить строку</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon
											small
											@click="copyRow(item.id)"
											v-on="on"
										>
											mdi-content-duplicate
										</v-icon>
									</template>
									<span>Скопировать строку</span>
								</v-tooltip>
							</div>
						</div>
						<div v-else-if="head.value === 'percent'" class="text-center percent">
							{{item[head.value]}}%
						</div>
            <div v-else-if="head.value === 'volume'" class="text-center percent">
							{{item[head.value]}}
						</div>
            <div v-else-if="head.value === 'volume_per'" class="text-center percent">
							{{item[head.value]}}
						</div>
						<div v-else-if="head.value === 'rowName'">
							<v-text-field
								:label="item[head.value] ? '' : 'Вписать...'"
								v-model="item[head.value]"
								@change="(val) => editField(val, item.id)"
								flat
								dense
							></v-text-field>
						</div>
						<div v-else-if="categories.filter(el => el.value === head.value)[0]" class="tab-row">
							<v-select
								:key="`${head.value}_${item.id}`"
								v-if="categories.filter(el => el.value === head.value)[0].items.length"
								:items="categories.filter(el => el.value === head.value)[0].items"
								item-text="label"
								item-value="value"
								v-model="item[head.value]"
								@change="(val) => editField(val, item.id)"
								flat
								dense
							>
							</v-select>
							<div v-else>
								<v-text-field
									:key="`${head.value}_${item.id}`"
									@blur="() => editField(item[head.value], item.id)"
									v-model="item[head.value]"
									:rules="[rules.validate]"
								>
								</v-text-field>
							</div>
						</div>
						<div v-else>
							{{item[head.value]}}
						</div>
					</td>
				</tr>
			</template>
			<template v-slot:body.append>
				<tr class="add-row">
					<td v-for="head in innerHeaders" :key="head.value" :class="head.value !== 'action' ? 'align-top': ''">
						<div v-if="head.value === 'action'">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn
										text
										icon
										small
										:disabled="disabledAddRow"
										@click="addRow(paramsValue)"
										v-on="on"
									>
										<v-icon
											color="green"
										>
											mdi-plus
										</v-icon>
									</v-btn>
								</template>
								<span>Добавить строку</span>
							</v-tooltip>
						</div>
						<v-text-field
							v-else-if="head.value === 'rowName'"
							v-model="paramsValue[head.value]"
							label="Название"
						></v-text-field>
						<div v-else-if="categories.filter(el => el.value === head.value)[0]">
							<v-select
								v-if="categories.filter(el => el.value === head.value)[0].items.length"
								:items="categories.filter(el => el.value === head.value)[0].items"
								item-text="label"
								item-value="value"
								:label="!!~head.text.indexOf('(') ? head.text.slice(0, head.text.indexOf('(') - 1) : head.text"
								v-model="paramsValue[head.value]"
							></v-select>
							<v-text-field
								v-else
								v-model="paramsValue[head.value]"
								:rules="[rules.validate]"
								:label="!!~head.text.indexOf('(') ? head.text.slice(0, head.text.indexOf('(') - 1) : head.text"
							>
							</v-text-field>
						</div>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-form>
</template>

<script>
  export default {
    name: "Table",
    data() {
      return {
        rules: {
          validate: (val) => {
            if (!val) return true;
            const pattern = /^[\d|\.]+$/;
            return (pattern.test(val) && val > 0) || 'Допустимы только положительные числа'
          }
        },
        valid: true,
      }
    },
    props: {
      headers: Array,
      rows: Array,
      hasStrategy: Boolean,
      showVolumes: Boolean,
      deleteRow: Function,
      copyRow: Function,
      importance: Object,
      categories: Array,
      rowsValue: Array,
      volumeSum: Number,
      saveRowChanges: Function,
      paramsValue: Object,
      addRow: Function,
    },
    computed: {
      innerHeaders: function () {
        return [{text: 'Название', align: 'center', value: 'rowName', width: 150}]
          .concat(this.$props.headers.map(el => {
            return {
              text: `${el.label} ${this.importance[el.value] ? `(${this.importance[el.value]})` : ''}`,
              value: el.value,
            }
          }))
          .concat(
            {text: 'Доля', align: 'center', value: 'percent'},
          )
          .concat(
              this.hasStrategy && this.showVolumes
                  ? [{text: `Объём (${this.volumeSum})`, align: 'center', value: 'volume'},
                    {text: 'Объём %', align: 'center', value: 'volume_per'}]
                  : []
          )
          .concat(
            {text: 'Действия', align: 'center', value: 'action', sortable: false},
          )
      },
      disabledAddRow: function () {
        const optional_fields = Object.keys(this.paramsValue)
          .filter(el => el !== 'rowName' && this.headers.filter(el_i => el_i.value === el)[0].items.length === 0);
        return !this.valid || Object.keys(this.paramsValue)
          .filter(el => el !== 'rowName' && !optional_fields.includes(el)) // исключаем из проверки при добавлении строки обязательность поля rowName и "открытых" полей
          .map(el => this.paramsValue[el])
          .filter(el => el || el === null).length !== this.headers.length - optional_fields.length;
      },
      concept: function () {
        return this.$route.params.concept
      }
    },
    methods: {
      editField(val, id) {
        if (!this.valid) return alert('error');
        const neededFields = Object.keys(this.rowsValue[0]);
        !neededFields.includes('rowName')
          ? neededFields.push('rowName')
          : null;
        let editingRow = this.rows.filter(el => el.id === id)[0];
        Object.keys(editingRow).map(el => {
          if (neededFields.indexOf(el) === -1) delete editingRow[el]
        });
        this.saveRowChanges(editingRow, id)
      }
    },
  }
</script>

<style scoped>
	td {
		font-weight: normal;
		border: 1px solid #e0e0e0;
	}

	.add-row {
		border-top: 2px solid #a8a8a8;
		background-color: rgba(224, 224, 224, .5);
	}

	.add-row td:last-child {
		padding-top: 0;
	}

	.v-input {
		font-size: small;
	}

	.percent {
		font-size: small;
		font-weight: bold;
	}
</style>

<style>
	td .v-input__slot::before {
		border-style: none !important;
	}

	thead tr th {
		background-color: #e0e0e0;
		vertical-align: top;
	}

	tbody tr td.align-top {
		vertical-align: top;
	}

	[aria-sort='none'] i {
		opacity: .75;
	}

	[aria-sort='none'] i::before {
		content: '';
	}

</style>
